var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeleteX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.570458 0.169278C0.776599 -0.0359074 1.09918 -0.0545606 1.32649 0.113318L1.39161 0.169278L6.40039 5.15455L11.4092 0.169278C11.6153 -0.0359074 11.9379 -0.0545606 12.1652 0.113318L12.2303 0.169278C12.4365 0.374463 12.4552 0.695544 12.2865 0.921802L12.2303 0.986623L6.81097 6.38083C6.60483 6.58601 6.28225 6.60467 6.05494 6.43679L5.98981 6.38083L0.570458 0.986623C0.343702 0.76092 0.343702 0.394982 0.570458 0.169278Z",
    fill: "#FF0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2303 11.8307C12.0242 12.0359 11.7016 12.0546 11.4743 11.8867L11.4092 11.8307L6.40039 6.84545L1.39161 11.8307C1.18547 12.0359 0.862894 12.0546 0.635581 11.8867L0.570458 11.8307C0.364316 11.6255 0.345576 11.3045 0.514237 11.0782L0.570458 11.0134L5.98981 5.61917C6.19595 5.41399 6.51853 5.39533 6.74584 5.56321L6.81097 5.61917L12.2303 11.0134C12.4571 11.2391 12.4571 11.605 12.2303 11.8307Z",
    fill: "#FF0909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteX);
export default __webpack_public_path__ + "static/media/icon-delete-X.b03076412d95ae872680bf90eefd2e63.svg";
export { ForwardRef as ReactComponent };